import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

// to be use
const headers = {
	Authorization: `Bearer ${token}`,
	"Content-Type": "application/json",
};

export const otherAdjustmentStagingService = {
	getPayrollOtherAdjustments: async (param) => {
		const response = await axios.get(`${domain}/api/OtherAdjustmentStaging/${param}`, {
			headers: headers,
		});
		return response;
	},
	
	getPayrollOtherLateAdjustments: async (param) => {
		const response = await axios.get(`${domain}/api/OtherAdjustmentStaging/${param}/late`, {
			headers: headers,
		});
		return response;
	}
};